<template>
    <div>
        <input type="checkbox" :value="itemValue" :name="itemValue" @change="update" v-model="active" class="hidden" :id="itemId">
        <label :for="itemId">{{ itemTitle }}</label>
    </div>
</template>

<script>
export default {
    props: {
     itemId: {
        required: true
      },
      itemValue: {
        required: true
      },
      itemTitle: {
        required: true
      }
    },
    data() {
        return {
            active: false
        }
    },
    methods: {
        update() {
            this.$emit('updated', { item: this.itemValue, active: this.active });
        }
    }
}
</script>